import { combineReducers } from 'redux';
import quizReducer from './quizReducer';

const rootReducer = combineReducers({
  quizDecision: quizReducer,
});

export default rootReducer;